import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import { Info } from 'lucide-react'
import type { ReactNode } from 'react'

interface InlineHelpTooltipProps {
	label: string
	content: ReactNode
	dataTestId: string
	/** Tone override, for help that sits inside a warning block rather than beside a field label. */
	className?: string
}

export function InlineHelpTooltip({ label, content, dataTestId, className }: InlineHelpTooltipProps) {
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<button
					type='button'
					aria-label={label}
					data-testid={dataTestId}
					onClick={event => event.stopPropagation()}
					className={cn('inline-flex shrink-0 cursor-help text-muted-foreground hover:text-foreground', className)}>
					<Info className='size-(--icon-standalone)' />
				</button>
			</TooltipTrigger>
			<TooltipContent side='top'>{content}</TooltipContent>
		</Tooltip>
	)
}
